"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ROLE_TABLE_HEIGHT = exports.CONTAINER_HEIGHT = exports.ROLE_TIME_FOOTER_HEIGHT = exports.SECTION_HEIGHT = exports.SECTION_ROW_HEIGHT = void 0;
exports.getSlotBackground = getSlotBackground;
exports.normalizeOvernightTimeSpan = normalizeOvernightTimeSpan;
exports.clampTimeSpanToTimeline = clampTimeSpanToTimeline;
exports.isTimelineBlockVisible = isTimelineBlockVisible;
exports.calculateTimelineBlockStyle = calculateTimelineBlockStyle;
exports.calculateRoleTimeLayout = calculateRoleTimeLayout;
exports.calculateRoleTimeHeight = calculateRoleTimeHeight;
exports.getRolePosition = getRolePosition;
const common_1 = require("../common/common");
exports.SECTION_ROW_HEIGHT = 27;
exports.SECTION_HEIGHT = 23;
exports.ROLE_TIME_FOOTER_HEIGHT = 32;
exports.CONTAINER_HEIGHT = 72;
exports.ROLE_TABLE_HEIGHT = 230;
function getSlotBackground(color) {
    const baseColor = color || "eef0f3";
    const secondaryColor = color ? `${color}80` : "eef0f3cc";
    return `repeating-linear-gradient(
    135deg,
    #${baseColor}40 0 15px,
    #${secondaryColor} 15px 30px
  )`;
}
function normalizeOvernightTimeSpan(start, end, timelineStart, timelineEnd) {
    if (!Number.isFinite(start) || !Number.isFinite(end) || !Number.isFinite(timelineStart) || !Number.isFinite(timelineEnd)) {
        return {
            start,
            end,
        };
    }
    let normalizedStart = start;
    let normalizedEnd = end;
    if (normalizedEnd < normalizedStart) {
        normalizedEnd += 24 * 60;
    }
    if (timelineEnd > 24 * 60) {
        const spanIsBeforeTimeline = normalizedStart < timelineStart && normalizedEnd < timelineStart;
        if (spanIsBeforeTimeline) {
            normalizedStart += 24 * 60;
            normalizedEnd += 24 * 60;
        }
    }
    return {
        start: normalizedStart,
        end: normalizedEnd,
    };
}
function clampTimeSpanToTimeline(start, end, timelineStart, timelineEnd) {
    const normalized = normalizeOvernightTimeSpan(start, end, timelineStart, timelineEnd);
    return {
        start: Math.max(timelineStart, normalized.start),
        end: Math.min(timelineEnd, normalized.end),
    };
}
function isTimelineBlockVisible(start, end, timelineStart, timelineEnd) {
    return Number.isFinite(start) && Number.isFinite(end) && timelineEnd > timelineStart && start < end;
}
function calculateTimelineBlockStyle(start, end, timelineStart, timelineEnd, options) {
    const timelineDuration = timelineEnd - timelineStart;
    if (!isTimelineBlockVisible(start, end, timelineStart, timelineEnd)) {
        return {};
    }
    const left = ((start - timelineStart) / timelineDuration) * 100;
    const right = ((end - timelineStart) / timelineDuration) * 100;
    return {
        marginLeft: `${Math.max(0, left)}%`,
        width: `${Math.max(0, Math.min(100, right - left))}%`,
        ...(options.minHeight === undefined ? {} : { minHeight: `${options.minHeight}px` }),
        ...(options.laneIndex === undefined ? {} : { gridRowStart: options.laneIndex + 1 }),
        background: options.background,
        color: options.color,
    };
}
function calculateRoleTimeLayout(sections, timeRange) {
    const { start: rangeStart, end: rangeEnd } = timeRange;
    const timelineStart = rangeStart * 60;
    const timelineEnd = rangeEnd * 60;
    const timedSections = (sections || [])
        .map((section) => {
        const rawStart = (0, common_1.kitchenTimeToDuration)(section.from || "", "minutes");
        const rawEnd = (0, common_1.kitchenTimeToDuration)(section.to || "", "minutes");
        const { start, end } = clampTimeSpanToTimeline(rawStart, rawEnd, timelineStart, timelineEnd);
        return {
            section,
            start,
            end,
        };
    })
        .filter((item) => item.start < item.end && timelineEnd > timelineStart)
        .sort((a, b) => {
        if (a.start !== b.start) {
            return a.start - b.start;
        }
        return a.end - b.end;
    });
    const laneEnds = [];
    const laneBySectionId = new Map();
    timedSections.forEach((item) => {
        const laneIndex = laneEnds.findIndex((endTime) => endTime <= item.start);
        if (laneIndex === -1) {
            laneEnds.push(item.end);
            laneBySectionId.set(item.section.id, laneEnds.length - 1);
            return;
        }
        laneEnds[laneIndex] = item.end;
        laneBySectionId.set(item.section.id, laneIndex);
    });
    return {
        laneBySectionId,
        laneCount: Math.max(1, laneEnds.length),
    };
}
function calculateRoleTimeHeight(laneCount) {
    return Math.max(exports.SECTION_HEIGHT, laneCount * exports.SECTION_ROW_HEIGHT - 4);
}
function getRolePosition(hour, start, end) {
    const range = end - start;
    if (!Number.isFinite(hour) || !Number.isFinite(start) || !Number.isFinite(end)) {
        return 0;
    }
    if (range === 0) {
        return 0;
    }
    return ((hour - start) / range) * 100;
}
